App.controller('LifeVariantCtrl', ['$scope', '$rootScope', '$sce', '$state', '$http', 'packageService', '$stateParams', '$mdDialog', 'Config', 'fieldsService', '$filter', '$timeout', 'lifeInsuranceService', 'popUpService', 'variantsMatrixService', function ($scope, $rootScope, $sce, $state, $http, packageService, $stateParams, $mdDialog, Config, fieldsService, $filter, $timeout, lifeInsuranceService, popUpService, variantsMatrixService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'life';
    $scope.$emit('page', $scope.page);

    $scope.step = $rootScope.CONFIGURATOR.lifeInsurance.variantsStepText ? $rootScope.CONFIGURATOR.lifeInsurance.variantsStepText: '';
    // $scope.step = 'Wybierz do 3 wariantów ubezpieczenia spośród Rodzina, Ochrona i Plus (krok 1)';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.life.start';
    $scope.$emit('link', $scope.link);

    $scope.groupwidth = [];
    $scope.singleLength = [];
    $scope.allLength = 0;
    $scope.singleItemGroupWeight = 2;

    $scope.alreadyHasDeclaration = !!$rootScope.__logged;
    $scope.disableSelection = true;

    $scope.isLifePackageHidden = function (person, group, item) {
        return person > 0 && $scope.lifePackages[group].disabledForFamilyMembers;
    };

    (function () {
        // function alreadyHasDeclarationPopUp() {
        //     console.log('$scope.alreadyHasDeclaration', $scope.alreadyHasDeclaration);
        //     if($scope.alreadyHasDeclaration){
        //         $scope.showPopUp('', '', 'Aby zmienić wariant ubezpieczenia, zmienić dane lub poszerzyć zakres ochrony dla Ciebie i rodziny, wejdź w zakładkę Moje deklaracje.');
        //     }
        // }

        if(!$rootScope.__logged){
            return;
        }

        lifeInsuranceService.getGroupedDeclarations()
            .then(function (success) {
                var userGroup = success.data.list.find(function (group) {
                    return group.type === 'USER';
                });
                if(!userGroup || !userGroup.declarations || !userGroup.declarations.length){
                    $scope.alreadyHasDeclaration = false;
                    return;
                }

                var userDeclarations = userGroup.declarations;
                $scope.alreadyHasDeclaration = !!userDeclarations.find(function (decl) {
                    return decl.declaration.status === 'ACTIVE' || decl.declaration.status === "READY";
                });

                alreadyHasDeclarationPopUp();
            }, function (error) {
                $scope.alreadyHasDeclaration = true;
                console.error(error);
            });
    })();

    if ($scope.stateParams.choose && $scope.stateParams.prices) {
        $scope.choose = $scope.stateParams.choose;
        $scope.prices = $scope.stateParams.prices;
        $scope.persons = $scope.stateParams.persons;
        $scope.summary = $scope.stateParams.summary;
    } else {
        $scope.choose = [{}, {}, {}];
        $scope.prices = [{}, {}, {}];
        $scope.summary = 0;
    }
    if (!$scope.persons) {
        $scope.persons = [{
                "type": "USER",
                "name": "Ubezpieczony pracownik"
            },
            {
                "type": "SPOUSE",
                "name": "Współmałżonek lub partner",
                person: {
                    citizenshipType: "POLISH",
                    gender: "FEMALE"
                }
            },
            {
                "type": "CHILD",
                "name": "Pełnoletnie dziecko",
                person: {
                    citizenshipType: "POLISH",
                    gender: "FEMALE"
                }
            }
        ];
    }

    fieldsService.dataFieldsList().then(function (data) {
        $scope.fields = data.data.fields;
        for (let i = 0; i < $scope.fields.length; i++) {
            $scope.fields[i].name = $sce.trustAsHtml($scope.fields[i].name);
        }
    });

    packageService.dataLifeList().then(function (data) {
        $scope.lifePackages = data.data.group;

        variantsMatrixService.determineSingleAndAllLength($scope);
        variantsMatrixService.determineGroupwidth($scope);
    });

    popUpService.showPopUp({
        head: '',
        content: `Od 1 września obowiązują nowe warunki ubezpieczenia dostępne pod adresem: <a href="${$rootScope.CONFIGURATOR.CORE.NEW_PLATFORM}">${$rootScope.CONFIGURATOR.CORE.NEW_PLATFORM}</a>`,
        tpl: 'info-big'
    });

    // if (!$rootScope.__logged && $rootScope.CONFIGURATOR.lifeInsurance.newPackagesPopupEnabled) {
    //     popUpService.showPopUp({
    //         head: '',
    //         content: 'Jeżeli posiadasz już ubezpieczenie na życie i chcesz zmienić wariant, dodać nową deklarację dla członka rodziny bądź dobrać wariant W Razie Wypadku lub Dzieci to najpierw zaloguj się na konto i przejdź do zakładki Moja deklaracja -> Dodaj deklarację.',
    //         tpl: 'info-big'
    //     });
    // }

    $scope.list = function() {
        $state.go('root.life.list');
    };

    $scope.next = function () {
        if($scope.alreadyHasDeclaration){
            return;
        }
        if (!Object.keys($scope.choose[0]).length) {
            if (Object.keys($scope.choose[1]).length || Object.keys($scope.choose[2]).length) {
                $scope.showPopUp('', 'Dokonaj wyboru wariantu ubezpieczenia', 'Aby zgłosić do ubezpieczenia Współmałżonka/Partnera i/lub Pełnoletnie dziecko, należy najpierw wybrać wariant ubezpieczenia dla Pracownika.');
            } else {
                $scope.showPopUp('', 'Dokonaj wyboru wariantu ubezpieczenia', 'Aby kontynuować zaznacz minimum jeden wariant dla pracownika.');
            }
            return 0;
        }

        if (!$rootScope.__logged) {
            setTimeout(function () {
                window.location.href = "/zaloz-konto";
            }, 1);
            return;
        } else {
            // if (!notCheckValidAge) {
            //     var userObject = JSON.parse(window.sessionStorage.getItem('userObject'));
            //     if (userObject) {
            //         if (!validateAge(userObject.person)) return;
            //     }
            // }
        }

        $state.go('root.life.salaried', {
            persons: $scope.persons,
            choose: $scope.choose,
            prices: $scope.prices,
            summary: $scope.summary
        });
    };

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.confirm = function () {
            $scope.locals.confirm = true;
            $mdDialog.hide($scope.locals);
        };
    }
    PopUpInfoCtrl.$inject = ['$scope', '$mdDialog', 'locals'];

    $scope.showPopUp = function (ev, head, content, text, target, notClose, nextStep) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/' + 'info-big.html',
            targetEvent: ev,
            clickOutsideToClose: !notClose,
            locals: {
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                },
                notClose: !notClose,
                nextStep: nextStep
            }
        }).then(function (data) {
            if (data.confirm && data.nextStep) {
                $scope.notCheckValidAge = true;
                $scope.next();
            }
        }, function () {

        });
    };

    function validateAge(person) {
        if (person.citizenshipType === 'POLISH') {
            if ($filter('isOver75FromIdentifier')(person.identifier)) {
                $scope.showPopUp('', 'Informacja', 'Do ubezpieczenia mogą przystąpić osoby, które nie ukończyły 75 lat.', 'Wróć do strony głównej', 'root.dashboard', true);
                return 0;
            }

        } else {
            if ($filter('isOver75FromBirthdate')(new Date(person.birthdate))) {
                $scope.showPopUp('', 'Informacja', 'Do ubezpieczenia mogą przystąpić osoby, które nie ukończyły 75 lat.', 'Wróć do strony głównej', 'root.dashboard', true);
                return 0;
            }
        }
        return 1;
    }

    var limitedPopupConfig = $rootScope.CONFIGURATOR.lifeInsurance.limitedTimePopup;
    if (limitedPopupConfig.limitedTimePopupEnabled) {
        var dateNow = moment().toDate();
        var dateTo = moment(limitedPopupConfig.limitedTimePopupDateTo).toDate();
        dateTo.setHours(23, 59, 59, 999);

        if (dateTo.getTime() <= dateNow.getTime()) return;

        var config = {
            head: limitedPopupConfig.limitedTimePopupHeading,
            content: limitedPopupConfig.limitedTimePopupContent,
            tpl: 'info-big'
        };

        popUpService.showPopUp(config);
    }
}]);
